import store from "../redux";
import {removeStorage} from "./index";
import {
    setUserList,
    setUserInfo,
    collapsedToggle,
    setBreadcrumb,
    setReload,
    setMenu,
    setYear,
    setIds,
    setLbname
} from "../redux/common/action";

export const clearboth = function (){
    removeStorage('login','session')
    removeStorage('menu')
    removeStorage('userInfo')
    removeStorage('userList')
    removeStorage('year')
    removeStorage('showids')
    removeStorage('lbname')
    removeStorage('persist:root')
    removeStorage('chooseid')
    removeStorage('api')
    store.dispatch(setUserList({}))
    store.dispatch(setUserInfo(null))
    store.dispatch(collapsedToggle('default'))
    store.dispatch(setBreadcrumb([]))
    store.dispatch(setReload(false))
    store.dispatch(setMenu([]))
    store.dispatch(setYear(''))
    store.dispatch(setIds(''))
    store.dispatch(setLbname(''))
    clearAllCookie()
}
//清除所有cookie函数
function clearAllCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if(keys) {
        for(var i = keys.length; i--;)
            document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
}
